import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import popupTemplate from 'text!../../../templates/audioEditor/SequencerNodeMoreOptionContent.html';
import ti18n from "i18n!nls/Sequenceri18n";


const SequencerNodeMoreOptionContentView = Backbone.View.extend({


    initialize : function(options) {

        this.compiledTemlate =  _.template(popupTemplate);
        this.model = options? options.model : null;
        this._templateParams = {"model" : this.model, "ti18n": ti18n, "deleteAllExceptSelectedAvailable": options.deleteAllExceptSelectedAvailable, "clippingAvailble": options.clippingAvailable,"createClipAvailble":options.createClipAvailble, "cutAvailable":options.cutAvailable,"copyAvailable": options.copyAvailable, "pasteAvailable": options.pasteAvailable,"transcriptCorrectionAvailable": options.transcriptCorrectionAvailable,"adjustTimingAvailable": options.adjustTimingAvailable,"changeSpeakerAvailable": options.changeSpeakerAvailable,"breakParagraphBeforeSelectionAvailable": options.breakParagraphBeforeSelectionAvailable,"breakParagraphAfterSelectionAvailable": options.breakParagraphAfterSelectionAvailable,"mergeWithPreviousParagraphAvailable": options.mergeWithPreviousParagraphAvailable,"mergeWithNextParagraphAvailable": options.mergeWithNextParagraphAvailable,"downloadClipAvailble": options.downloadClipAvailble };
    },
    
    events : {
        "click #cutBtn:not(.disabled)": "onCutButtonClicked",
        "click #copyBtn:not(.disabled)": "onCopySelectionToClipboardClicked",
        "click #pasteBtn:not(.disabled)": "onPasteButtonClicked",
        "click #clipSelection:not(.disabled)": "onClipButtonClicked",
        "click #createClipSelection:not(.disabled)": "onCreateClipButtonClicked",
        "click #downloadClip:not(.disabled)": "onDownloadClipButtonClicked",
        "click #editTranscriptBtn:not(.disabled)": "onCorrectTranscriptionButtonClicked",
        "click #adjustTimingBtn:not(.disabled)": "onAdjustTimingButtonClicked",
        "click #changeSpeakerBtn:not(.disabled)": "onChangeSpeakerButtonClicked",
        "click #breakParagraphBeforeBtn:not(.disabled)": "onBreakParagraphBeforeButtonClicked",
        "click #breakParagraphAfterBtn:not(.disabled)": "onBreakParagraphAfterButtonClicked",
        "click #mergeParagraphPreviousBtn:not(.disabled)": "onMergeWithPreviousParagraphButtonClicked",
        "click #mergeParagraphNextBtn:not(.disabled)": "onMergeWithNextParagraphButtonClicked",
        "click #deleteAllExceptSelectedBtn:not(.disabled)":"onDeleteAllExceptSelectedNodesButtonClicked",
    },

    onCutButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("cutAndCopySelectionToClipboard");
        }
    },

    onCopySelectionToClipboardClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("copySelectionToClipboard");
        }
    },


    onPasteButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("paste");
        }
    },

    onClipButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("clip");
        }
    },

    onCreateClipButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("createClip");
        }
    },

    onDownloadClipButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("download");
        }
    },


    onCorrectTranscriptionButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("correctTranscript");
        }
    },

    onAdjustTimingButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("adjustTiming");
        }
    },

    onChangeSpeakerButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("changeSpeaker");
        }
    },

    onBreakParagraphBeforeButtonClicked : function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("breakParagraphBeforeSelection");
        }
    },

    onBreakParagraphAfterButtonClicked : function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("breakParagraphAfterSelection");
        }
    },

    onMergeWithPreviousParagraphButtonClicked : function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("mergeWithPreviousParagraph");
        }
    },

    onMergeWithNextParagraphButtonClicked : function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("mergeWithNextParagraph");
        }
    },

    onDeleteAllExceptSelectedNodesButtonClicked :function(event){
        if(!$(event.target).hasClass("disabled")){
            this.trigger("deleteAllExceptSelectedNodes");
        }
    },

    getModel: function(){
        return this.model;
    },

    render : function() {
        
        this.$el.html(this.compiledTemlate(this._templateParams));
        this.setElement(this.$el.find("ul").first());
        return this;
    }

    
    

});
export default SequencerNodeMoreOptionContentView;
